module.exports = __webpack_public_path__ + "img/content_voice_2.3882de96.png";